import { render, staticRenderFns } from "./ObjektiCard1.vue?vue&type=template&id=f7b0effa&scoped=true&"
import script from "./ObjektiCard1.vue?vue&type=script&lang=ts&"
export * from "./ObjektiCard1.vue?vue&type=script&lang=ts&"
import style0 from "./ObjektiCard1.vue?vue&type=style&index=0&id=f7b0effa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b0effa",
  null
  
)

export default component.exports